import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import ContractsTable from './ContractsTable';

import { modalOptions } from 'Helpers/modalOptions';

import Modal from 'CommonComponents/Modal';

import useApiRequest from 'Hooks/useApiRequest';
import useModal from 'Hooks/useModal';

const ExpenditureContractsModal = ({ fetchExpenseContractsUrl }) => {
    const [expenseId, setExpenseId] = useState(document.getElementById('ExpenditureContractsModalApp').getAttribute('data-expense-id'));
    const [contracts, setContracts] = useState([]);

    const modal = useModal({
        options: {
            ...modalOptions(true),
            backdrop: 'dynamic',
        },
    });

    const expenseContractsRequest = useApiRequest({
        url: fetchExpenseContractsUrl,
    });

    useEffect(() => {
        const targetNode = document.getElementById('ExpenditureContractsModalApp');

        // Callback function to execute when mutations are observed
        const callback = function (mutationsList, observer) {
            for (const mutation of mutationsList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'data-expense-id') {
                    const newExpenseId = mutation.target.getAttribute('data-expense-id');
                    setExpenseId(newExpenseId);

                    modal.show();
                }
            }
        };

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, { attributes: true });

        // Cleanup function to stop observing when the component unmounts
        return () => {
            observer.disconnect();
        };
    }, []);

    useEffect(() => {
        setContracts(expenseContractsRequest.data?.data || []);
    }, [expenseContractsRequest.data]);

    useEffect(() => {
        if (expenseId) {
            fetchContracts(expenseId);
        }
    }, [expenseId]);

    const fetchContracts = (expenseId) => {
        expenseContractsRequest.get(null, { EXPENSE_ID: expenseId });
    };

    return (
        <Modal id="expenditure-contracts-modal" modal={modal} innerContainerClasses="tw-bg-[#F8F8F8]" containerStyle={{ maxWidth: 'none', width: 'auto' }}>
            <ContractsTable isLoading={expenseContractsRequest.loading} contracts={contracts} />
        </Modal>
    );
};

if (document.getElementById('ExpenditureContractsModalApp')) {
    var rootEl = document.getElementById('ExpenditureContractsModalApp');
    var fetchExpenseContractsUrl = rootEl.getAttribute('data-fetch-expense-contracts-url');
    ReactDOM.render(
        <App>
            <ExpenditureContractsModal fetchExpenseContractsUrl={fetchExpenseContractsUrl} />
        </App>,
        rootEl,
    );
}
